package com.eladfinish.bible.contest.common.settings

import com.russhwolf.settings.Settings

class RusshwolfKeyValueSettings(
    private val settings: Settings,
) : KeyValueSettings {

    override fun getBoolean(
        key: String,
        defaultValue: Boolean,
    ): Boolean =
        settings.getBoolean(
            key = key,
            defaultValue = defaultValue,
        )

    override fun getInt(
        key: String,
        defaultValue: Int,
    ): Int =
        settings.getInt(
            key = key,
            defaultValue = defaultValue,
        )

    override fun getString(
        key: String,
        defaultValue: String,
    ): String =
        settings.getString(
            key = key,
            defaultValue = defaultValue,
        )

    override fun putBoolean(
        key: String,
        value: Boolean,
    ) {
        settings.putBoolean(
            key = key,
            value = value,
        )
    }

    override fun putInt(
        key: String,
        value: Int,
    ) {
        settings.putInt(
            key = key,
            value = value,
        )
    }

    override fun putString(
        key: String,
        value: String,
    ) {
        settings.putString(
            key = key,
            value = value,
        )
    }

    override fun contains(key: String): Boolean =
        settings.hasKey(key)
}
